import Utils from "../utils/utils"

export class FeaturedAsset {
    public description = ""
    // Todo create media model
    public media: any[] = []
    public mediaType = ""
    public posterImage: any = null
    public title = ""

    constructor(input) {
        Object.keys(input).map((key) => {
            const property = Utils.convertToCamelcase(key)
            this[property] = input[key]
        })
        this.posterImage = Utils.escapePosterImage(this.posterImage)
    }
}
